import styled from 'styled-components';

const Block = styled.div`
  position: absolute;
  transform: scale(0);
`;

export default Block;
